import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from './../../services/app.service';
import { UserService } from '../../shared/services/user.service';
import { User } from '../../models/user.model';
import { GenericModel } from '../../models/generic.model'
import { environment } from '../../../environments/environment';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { Branch } from 'src/app/models/branch.model';
import { Session } from 'src/app/models/session.model';
import { Router } from '@angular/router';
import { ParentService } from 'src/app/pages/parent/services/parent.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ToastNotificationService } from 'src/app/shared/services/toast-notify.service';
import { SubscriptionComponent } from '../navbar-admin/subscription.component';
import { GlobalConstants } from 'src/app/shared/util/global.constant';


@Component({
  selector: 'app-navbar-superadmin',
  templateUrl: './navbar-superadmin.component.html',
  styleUrls: ['./navbar-superadmin.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarSuperAdminComponent implements OnInit {

  constructor(
      private appService: AppService,private userService: UserService,private modalService: NgbModal,
      private tokenStorageService: TokenStorageService, private router: Router,private configService: ConfigService,
      private parentService: ParentService,private toastNotifyService: ToastNotificationService,) {
    }

  modalRef: NgbModalRef; 
  isCollapsed = true;
  orgName: string;
  userDetail: GenericModel<User>;
  userId: string;
  profilePicUrl: string = '';
  branch: Branch;
  session: Session;
  sidebarPinned: boolean;

  ngOnInit() {
    console.log('*****Navbar SuperAdminComponent****');
    let hostname = window.location.hostname; // get tenant i.e subdomain from "subdomain.domain.com"
    let tenant = 'DemoTenant'
    if(hostname == 'localhost'){
      tenant = environment.defaultTenant
    }else{
      tenant= hostname.substring(0, hostname.indexOf('.'));
    }
    console.log(">>>>>Host Name:: "+hostname+' :tenant:>>>'+tenant);
    this.profilePicUrl = environment.authBase+environment.clientLogoUrl+tenant+'?X-TenantID='+tenant;  
    this.getBranchDetail();  
    this.getActiveSession();
  }

  getBranchDetail(){
    console.log('>>>>>getBranchDetail- navbar-superadmin>>>>> ')
    let branchCode = this.tokenStorageService.getBranchCode();
    let tenantName = this.tokenStorageService.getTenantName();
    this.userService.getBranchDetail(branchCode,tenantName).subscribe({
      next: (response: any) => {
        console.log(">>>getBranchDetail from service:navbar superaadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.branch =  response.data;
          if(this.branch){
            this.tokenStorageService.saveBranchName(this.branch.branchName);
          } 
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getBranchDetail....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }
  getActiveSession(){
    console.log('>>>>>getActiveSession- navbar-superadmin>>>>> ')
    this.userService.getActiveSession().subscribe({
      next: (response: any) => {
        console.log(">>>getActiveSession from service:navbar superaadmin- "+JSON.stringify(response));
        if(response.status == environment.SUCCESS){
          this.session =  response.data;
          if(this.session){
            this.tokenStorageService.saveAcademicSession(this.session.sessionYear);
          }          
        }else if(response.status == environment.FAILURE){    
          console.log('!!! Failure response in getActiveSession....')      
          //this.toastNotifyService.showErrorWithTimeout(response.message, "Notification", 7000);
        }           
      },
      error: (e) => {
        console.error('!!! Error in getBranchDetail: ',e);          
      }
    });
  }
  changeSession(){
    this.router.navigate(['superadmin/session']);
  }
  viewSubscriptionStatus(){
      console.log('----------viewSubscriptionStatus-----------------');
      let tenant = this.configService.getConfiguration().clientName; 
      console.log('tenant>>>>>>>'+tenant);
      this.parentService.getSubscribedFeatures(tenant).subscribe(
        res => {
          console.log('Tenant Detaisl>>>>>>>'+JSON.stringify(res.data));
          if(environment.SUCCESS == res.status){
            this.modalRef = this.modalService.open(SubscriptionComponent, { windowClass : "modal-holder", centered: false, size: 'md', backdrop:'static'});
            this.modalRef.componentInstance.tenantDetail = res.data;
            this.modalRef.componentInstance.modalRef = this.modalRef;
            
          }else if(environment.FAILURE == res.status){
            this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 10000);
          }
        },
        error => console.log(error),
      );
      this.modalRef.result.then(() => {
        console.log('****viewSubscriptionStatus- modalref then******');
        //this.getStudentList();      
      });
    }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
    console.log('--------------toggleSidebarPin------------',this.appService.isSidebarPinned);
    this.sidebarPinned = this.appService.isSidebarPinned;
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
}
